export default "__VITE_ASSET__BtOcRDRT__"